import '../../utils/index.mjs';
import _sfc_main from './src/avatar2.mjs';
export { avatarEmits, avatarProps } from './src/avatar.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAvatar = withInstall(_sfc_main);

export { ElAvatar, ElAvatar as default };
//# sourceMappingURL=index.mjs.map
